module.exports = __webpack_public_path__ + "static/media/icon_n_solicitud.1886038c.svg";